import styled from 'styled-components';

export const ControlCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing1};
  background: ${({ theme }) => theme.designToken.baseWhite};
  padding: ${({ theme }) => theme.designToken.spacing1};
`;
